/**
 * Thanh công cụ danh sách người dùng admin — ô tìm kiếm và tiêu đề danh sách.
 */
export const AdminUsersListToolbar = ({ searchInput, onSearchChange, placeholder, listTitle }) => (
  <div className="admin-users-toolbar">
    <label className="admin-users-search">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <circle cx="11" cy="11" r="7" />
        <path d="M20 20l-3.5-3.5" strokeLinecap="round" />
      </svg>
      <input
        type="text"
        inputMode="search"
        enterKeyHint="search"
        role="searchbox"
        name="admin-users-filter"
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
        value={searchInput}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder={placeholder}
      />
    </label>
    <h2 className="admin-users-list-title">{listTitle}</h2>
  </div>
);
